(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const header = $('[data-header]');
  const menuToggle = $('[data-menu-toggle]');
  const mobileMenu = $('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    const closeMobileMenu = () => {
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.setAttribute('aria-label', 'Menü öffnen');
      mobileMenu.hidden = true;
      document.body.classList.remove('sp-menu-open');
    };
    const openMobileMenu = () => {
      menuToggle.setAttribute('aria-expanded', 'true');
      menuToggle.setAttribute('aria-label', 'Menü schließen');
      mobileMenu.hidden = false;
      document.body.classList.add('sp-menu-open');
    };
    menuToggle.addEventListener('click', () => {
      const open = menuToggle.getAttribute('aria-expanded') === 'true';
      open ? closeMobileMenu() : openMobileMenu();
    });
    $$('a,button', mobileMenu).forEach(el => el.addEventListener('click', closeMobileMenu));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMobileMenu(); });
    addEventListener('resize', () => { if (innerWidth > 980) closeMobileMenu(); }, {passive:true});
  }

  const progress = $('[data-scroll-progress]');
  const updateScrollState = () => {
    const y = scrollY || 0;
    header?.classList.toggle('is-scrolled', y > 12);
    if (progress) {
      const max = Math.max(1, document.documentElement.scrollHeight - innerHeight);
      progress.style.transform = `scaleX(${Math.min(1, y / max)})`;
    }
    document.documentElement.style.setProperty('--sp-page-scroll', `${Math.min(1, y / Math.max(1, innerHeight * 1.6))}`);
  };
  addEventListener('scroll', updateScrollState, {passive:true});
  addEventListener('resize', updateScrollState, {passive:true});
  updateScrollState();

  function bindDialog(openSelector, dialogSelector, closeSelector) {
    const dialog = $(dialogSelector);
    if (!dialog) return;
    $$(openSelector).forEach(btn => btn.addEventListener('click', () => dialog.showModal()));
    $$(closeSelector, dialog).forEach(btn => btn.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
  }
  bindDialog('[data-imprint-open]', '[data-imprint-dialog]', '[data-imprint-close]');
  bindDialog('[data-contact-open]', '[data-contact-dialog]', '[data-contact-close]');

  const filters = $$('[data-filter]');
  const productGrid = $('[data-product-grid]');
  const cards = productGrid ? $$('[data-product-card]', productGrid) : [];
  filters.forEach(btn => btn.addEventListener('click', () => {
    const filter = btn.dataset.filter;
    filters.forEach(x => x.classList.toggle('is-active', x === btn));
    cards.forEach(card => card.hidden = filter !== 'all' && card.dataset.kind !== filter);
  }));

  function initReveal(scope = document) {
    const selectors = [
      '.sp-section-head','.sp-custom__headline','.sp-material-card','.sp-colors__copy','.sp-color-visual',
      '.sp-color-rules>div','.sp-more-products__grid article','.sp-price-row','.sp-process__grid article',
      '.sp-accordion details','.sp-inquiry__intro','.sp-inquiry__form-wrap','.sp-final-contact__inner',
      '.sp-service-grid article','.sp-product-card','.sp-product-media','.sp-product-info'
    ];
    const nodes = selectors.flatMap(sel => $$(sel, scope)).filter(el => !el.dataset.revealInit);
    nodes.forEach((el, index) => {
      el.dataset.revealInit = '1';
      el.classList.add('sp-reveal');
      if (el.matches('.sp-colors__copy,.sp-inquiry__intro,.sp-product-media')) el.classList.add('sp-reveal--left');
      if (el.matches('.sp-color-visual,.sp-inquiry__form-wrap,.sp-product-info')) el.classList.add('sp-reveal--right');
      el.style.setProperty('--sp-reveal-delay', `${Math.min((index % 6) * 70, 350)}ms`);
    });
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(el => el.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {threshold:.12, rootMargin:'0px 0px -7% 0px'});
    nodes.forEach(el => observer.observe(el));
  }
  initReveal();

  const heroVisual = $('[data-hero-visual]');
  if (heroVisual && !reduceMotion && matchMedia('(pointer:fine)').matches) {
    heroVisual.addEventListener('pointermove', e => {
      const r = heroVisual.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - .5;
      const y = (e.clientY - r.top) / r.height - .5;
      heroVisual.style.setProperty('--sp-hero-x', `${x * 16}px`);
      heroVisual.style.setProperty('--sp-hero-y', `${y * 14}px`);
      heroVisual.style.setProperty('--sp-hero-rx', `${-y * 5}deg`);
      heroVisual.style.setProperty('--sp-hero-ry', `${x * 7}deg`);
    });
    heroVisual.addEventListener('pointerleave', () => {
      ['--sp-hero-x','--sp-hero-y','--sp-hero-rx','--sp-hero-ry'].forEach(v => heroVisual.style.removeProperty(v));
    });
  }

  function initQuantity(scope) {
    $$('[data-quantity]', scope).forEach(box => {
      if (box.dataset.qtyInit) return; box.dataset.qtyInit = '1';
      const input = $('input[type="number"]', box);
      $('[data-qty-minus]', box)?.addEventListener('click', () => { input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1); });
      $('[data-qty-plus]', box)?.addEventListener('click', () => { const max = Number(input.max || 9999); input.value = Math.min(max, Number(input.value || 1) + 1); });
    });
  }

  function initThumbs(scope) {
    const media = $('.sp-product-media', scope);
    if (!media || media.dataset.thumbsInit) return; media.dataset.thumbsInit = '1';
    const main = $('.sp-product-media__main img', media);
    $$('[data-product-thumb]', media).forEach(btn => btn.addEventListener('click', () => {
      if (!main) return;
      main.src = btn.dataset.imageSrc;
      $$('[data-product-thumb]', media).forEach(x => x.classList.toggle('is-active', x === btn));
    }));
  }

  function initStock(scope) {
    const liveStock = $('[data-live-stock]', scope);
    const content = $('[data-product-content]', scope);
    const refreshUrl = content?.dataset.stockRefreshUrl;
    if (!liveStock || !refreshUrl || liveStock.dataset.stockInit) return;
    liveStock.dataset.stockInit = '1';
    const refresh = async () => {
      try {
        const sep = refreshUrl.includes('?') ? '&' : '?';
        const r = await fetch(`${refreshUrl}${sep}_=${Date.now()}`, {headers:{'X-Requested-With':'XMLHttpRequest'}, cache:'no-store'});
        if (!r.ok) return;
        const html = await r.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = $('[data-live-stock]', doc);
        if (!fresh) return;
        const nowStrong = $('strong', liveStock), freshStrong = $('strong', fresh);
        if (nowStrong && freshStrong) nowStrong.textContent = freshStrong.textContent;
        const width = $('i b', fresh)?.style.width;
        if (width && $('i b', liveStock)) $('i b', liveStock).style.width = width;
        const freshQty = $('.sp-quantity input', doc), currentQty = $('.sp-quantity input', scope);
        if (freshQty?.max && currentQty) { currentQty.max = freshQty.max; if (+currentQty.value > +freshQty.max) currentQty.value = freshQty.max; }
      } catch (_) {}
    };
    setInterval(refresh, 25000);
  }

  function initF2(scope) {
    const f2 = $('[data-f2-key]', scope), audio = $('[data-f2-audio]', scope), dispatch = $('[data-dispatch]', scope), codeLayer = $('[data-dispatch-codes]', scope);
    if (!f2 || !audio || !dispatch || !codeLayer || f2.dataset.f2Init) return; f2.dataset.f2Init = '1';
    const codes = ['001OX','001OD','001OAR','001OT','001MT','001OI','010OX','010MX','010MI','110MX','111MNF','110MRTH','110MSRE','230MX','120MX','MANV1','MANV2','MANV3','020MX','030MX','RDGA','130MX','220MX'];
    let active = false;
    const stop = () => { active=false; dispatch.hidden=true; dispatch.setAttribute('aria-hidden','true'); codeLayer.replaceChildren(); document.body.classList.remove('sp-alarm-active'); f2.disabled=false; f2.classList.remove('is-pressed'); };
    f2.addEventListener('click', async () => {
      if (active) return; active=true; f2.disabled=true; f2.classList.add('is-pressed'); codeLayer.replaceChildren();
      const count = innerWidth < 700 ? 110 : 120;
      for (let i=0;i<count;i++) {
        const s=document.createElement('span'); s.className='sp-dispatch-code'; s.textContent=codes[Math.floor(Math.random()*codes.length)];
        s.style.setProperty('--x',`${Math.random()*100}vw`); s.style.setProperty('--y',`${Math.random()*100}vh`); s.style.setProperty('--r',`${-35+Math.random()*70}deg`); s.style.setProperty('--d',`${.65+Math.random()*1.4}s`); s.style.setProperty('--delay',`${Math.random()*.25}s`);
        if (Math.random()>.78) s.classList.add('is-hot'); if (Math.random()>.9) s.classList.add('is-big'); codeLayer.appendChild(s);
      }
      dispatch.hidden=false; dispatch.setAttribute('aria-hidden','false'); document.body.classList.add('sp-alarm-active');
      audio.loop=false; audio.pause(); audio.currentTime=0; audio.onended=stop; audio.onerror=stop;
      try { await audio.play(); } catch (_) { setTimeout(stop,1800); }
    });
  }

  function initProductContent(scope = document) {
    initQuantity(scope); initThumbs(scope); initStock(scope); initF2(scope); initReveal(scope);
  }
  initProductContent();

  async function sha256(value) {
    const data = new TextEncoder().encode(value);
    const hash = await crypto.subtle.digest('SHA-256', data);
    return [...new Uint8Array(hash)].map(b => b.toString(16).padStart(2,'0')).join('');
  }

  const protectedProduct = $('[data-protected-product]');
  if (protectedProduct) {
    const gate = $('[data-access-gate]', protectedProduct);
    const mount = $('[data-protected-mount]', protectedProduct);
    document.body.classList.add('sp-protected-locked');
    let loading = false;

    const loadProtected = async () => {
      if (loading || !mount || mount.dataset.loaded === '1') return;
      loading = true;
      const status = $('[data-access-status]', protectedProduct);
      if (status) status.textContent = 'Geschützte Produktdaten werden geladen …';
      try {
        const url = protectedProduct.dataset.protectedUrl;
        const sep = url.includes('?') ? '&' : '?';
        const r = await fetch(`${url}${sep}_=${Date.now()}`, {headers:{'X-Requested-With':'XMLHttpRequest'}, cache:'no-store'});
        if (!r.ok) throw new Error('load');
        const html = await r.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const payload = $('[data-protected-payload]', doc);
        if (!payload) throw new Error('payload');

        mount.innerHTML = payload.innerHTML;
        mount.dataset.loaded = '1';
        mount.hidden = false;
        if (gate) gate.hidden = true;
        protectedProduct.classList.add('is-unlocked');
        document.body.classList.remove('sp-protected-locked');
        window.scrollTo({top: 0, behavior: 'instant'});
        initProductContent(mount);
      } catch (_) {
        mount.innerHTML = '';
        mount.hidden = true;
        if (status) status.textContent = 'Der geschützte Bereich konnte nicht geladen werden. Bitte erneut versuchen.';
      } finally {
        loading = false;
      }
    };

    $('[data-access-form]', protectedProduct)?.addEventListener('submit', async e => {
      e.preventDefault();
      const input = $('[data-access-input]', protectedProduct);
      const error = $('[data-access-error]', protectedProduct);
      const status = $('[data-access-status]', protectedProduct);
      if (!input || protectedProduct.dataset.accessReady !== 'true') return;
      if (error) error.hidden = true;
      if (status) status.textContent = '';
      const digest = await sha256(input.value.trim());
      if (digest === protectedProduct.dataset.accessHash) {
        input.disabled = true;
        await loadProtected();
      } else {
        if (error) error.hidden = false;
        input.select();
        protectedProduct.classList.add('is-denied');
        setTimeout(() => protectedProduct.classList.remove('is-denied'), 380);
      }
    });
  }
})();
